import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
// import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { PrimengModule } from './primeng.module';
import { FilterComponent } from '../../main/filter/filter.component';
import { ProfileimageComponent } from 'app/main/profileimage/profileimage.component';
import { DashboardOnLeaveComponent } from '../dashboard-on-leave/dashboard-on-leave.component';
import { ImageCropperModule } from 'ngx-image-cropper';
import { UserAttendanceComponent } from '../user-attendance/user-attendance.component';
import { FullCalendarModule } from '@fullcalendar/angular';
import { FormComponent } from '../form/form.component';

@NgModule({
    declarations: [
        FilterComponent,
        ProfileimageComponent,
        DashboardOnLeaveComponent,
        UserAttendanceComponent,
        FormComponent
    ],
    imports: [
        CommonModule,
        TranslateModule,
        HttpClientModule,
        FormsModule,
        ImageCropperModule,
        PrimengModule,
        FullCalendarModule
    ],
    exports: [
        FilterComponent,
        ProfileimageComponent,
        DashboardOnLeaveComponent,
        UserAttendanceComponent,
        FormComponent
    ]
})

export class SharedModule {
}
